import { useQuery } from '@tanstack/react-query'

import { getPointStatistic } from 'lib/api/point/getPointStatistic'

const useGetPointStatisticQuery = ({ expireDate }, options) => {
  return useQuery(['getPointStatistic', expireDate], () => getPointStatistic({ expireDate }), {
    ...options,
  })
}

export default useGetPointStatisticQuery
